import React, { useMemo } from 'react';
import { changesApi } from '../../../services/changesApi';
import ChangeFormFieldBuilder from './ChangeFormFieldBuilder';
import ChangePostImplEditorRolesPanel from './ChangePostImplEditorRolesPanel';

const ChangePostImplFormBuilder: React.FC = () => {
  const api = useMemo(
    () => ({
      load: changesApi.getPostImplFormSchema,
      createField: changesApi.createPostImplFormField,
      updateField: changesApi.updatePostImplFormField,
      deleteField: changesApi.deletePostImplFormField,
      reorderFields: changesApi.reorderPostImplFormFields,
    }),
    [],
  );
  return (
    <>
      <ChangePostImplEditorRolesPanel />
      <ChangeFormFieldBuilder
        heading="Formulário de pós-implantação"
        description="Segure o ícone ⋮⋮ e arraste para mudar a ordem. Os quatro sim/não do sistema não somem. Campos extras entram no registro de Revisar."
        api={api}
      />
    </>
  );
};

export default ChangePostImplFormBuilder;
